/* eslint no-undef: 0 */
/* eslint angular/document-service: 0 */

import angular from 'angular';

class ApiService {
    constructor(config, $http, $window, $injector, $rootScope, $translate) {
        this.apiUrl = config.apiUrl;
        this.$http = $http;
        this.$window = $window;
        this.$injector = $injector;
        this.$rootScope = $rootScope;

        this.data = [];
        this.dataLoaded = false;
        this.error = false;
        this.productId = '';
        this.configurationId = '';
        this.itemId = '';
        this.editSource = '';

        $translate('CART_URL').then((phrase) => {
            this.cartUrl = phrase;
        });
    }

    addToCart(withRedirect, editing, showAddedToCartPopup) {
        const dataService = this.$injector.get('dataService');
        const data = dataService.getObjectForApiRequest();
        $('#modal-accessories-reminder').modal('hide');

        this.saveProduct(data, withRedirect, editing, showAddedToCartPopup);
    }

    /**
     * Add or remove universal key accessory for all eligable products in cart
     *
     * @param {Boolean} status True when we want to add universal key and false when we want to delete it
     * @returns {Promise}
     */
    setUniversalKeyInCart(status) {
        const url = `${this.apiUrl}/set-universal-key-in-cart/${status}`;
        return this.$http({
            method: 'GET',
            url
        }).then(response => response.data);
    }

    getData() {
        let url = `${this.apiUrl}/get-product/`;
        url += `${this.productId}/`;
        url += `${this.configurationId}/`;
        url += (this.itemId) ? this.itemId : '';
        url = url.replace(/\/$/, "");
        return this.$http({
            method: 'GET',
            url
        }).then(response => response.data,
            () => {
                this.error = true;
            });
    }

    getMullionSetupsFromCart() {
        const url = `${this.apiUrl}/get-cart`;
        return this.$http({
            method: 'GET',
            url,
        }).then(response => response.data.data);
    }

    recalculatePrice(data) {
        data._csrfToken = $('meta[name="csrfToken"]').attr('content');
        return this.$http({
            method: 'POST',
            url: `${this.apiUrl}/calculate-product-price`,
            data
        }).then(request => request.data);
    }

    setApiUrl(url) {
        this.apiUrl = url;
    }

    setProductId(id) {
        this.productId = id;
    }

    setConfigurationId(id) {
        this.configurationId = id;
    }

    setItemId(id) {
        this.itemId = id;
    }

    setEditSourceType(type) {
        if (type) {
            this.editSource = type;
        } else {
            this.editSource = '';
        }
    }

    clearSvg(svgData) {
        let result = svgData.toString().trim().replace(/<!--(?!>)[\S\s]*?-->/g, '');
        const toChange = result.match(/id="iccDraw(?:[^"]*)"/g);

        if (toChange !== null) {
            toChange.forEach((element) => {
                const toChangeIdFrom = element.replace('id="', '').replace('"', '');
                const toChangeIdTo = toChangeIdFrom.replace(/-/g, '');
                result = result.replace(new RegExp(toChangeIdFrom, 'g'), toChangeIdTo);
                result = result.replace(/&quot;/g, '');
            });
        }
        result = result.replace(/"url\('?http(.*?)#(.*?)'?\)"/g, 'url(\'#$2\')');

        return result;
    }

    /**
     * Remove dimensions from door SVG visualization
     *
     * @param {String} svgData
     * @returns {String}
     */
    removeDimensionsFromDoorSvg(svgData) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = svgData;
        const elements = wrapper.querySelectorAll('.BottomDimension, .SideDimension');
        elements.forEach((element) => {
            element.parentNode.removeChild(element);
        });
        return wrapper.innerHTML;
    }

    saveProduct(data, withRedirect, editing, showAddedToCartPopup = true) {
        const productData = data;

        if (this.itemId) {
            productData.meta = {
                itemId: this.itemId
            };
        }
        const postData = data.data;

        // For doors SVG looks a little different
        if (productData.data[0].type === 'door') {
            const svgData = Array.from(document.getElementsByClassName('icc-door-draw-wrapper'))[1].innerHTML;
            const svgDataWithoutDimensions = this.removeDimensionsFromDoorSvg(svgData);
            postData[2] = this.clearSvg(svgData);
            postData[3] = this.clearSvg(svgDataWithoutDimensions);
        } else if (productData.data[0].type === 'roof_window') {
            postData[2] = null;
            postData[3] = null;
        } else {
            const svgData = Array.from(document.getElementsByTagName('icc-draw'))[2].innerHTML;
            const svgDataWithoutDimensions = Array.from(document.getElementsByTagName('icc-draw'))[1].innerHTML;
            postData[2] = this.clearSvg(svgData);
            postData[3] = this.clearSvg(svgDataWithoutDimensions);
        }
        if (this.editSource === 'cart' || this.editSource === '') {
            data._csrfToken = $('meta[name="csrfToken"]').attr('content');
            this.$http.post(`${this.apiUrl}/add-to-cart`, data).then(
                (response) => {
                    if (response.data.meta.success) {
                        const handlesService = this.$injector.get('handlesService');
                        let hasDoorsWithHandle = false;
                        let hasUniversalKeyEnabled = false;

                        response.data.data.forEach((product) => {
                            if (product.type === 'door' && product.has_handle) {
                                hasDoorsWithHandle = true;
                            }
                            if (product.type === 'door' && product.has_universal_key_enabled) {
                                hasUniversalKeyEnabled = true;
                            }
                        });
                        if (hasDoorsWithHandle) {
                            handlesService.showUniversalKey();
                            handlesService.setHandleOptions();
                        }
                        if (hasUniversalKeyEnabled) {
                            handlesService.setHandleOption('695');
                        }
                        if (editing || withRedirect) {
                            this.$window.location.href = '/' + this.cartUrl;
                        } else {
                            loadCart(); // jQuery method from product configure page scope
                            if (showAddedToCartPopup) {
                                this.$rootScope.$emit('savedToCartEvent');
                            }
                        }
                    }
                },
            );
        }

        if (this.editSource === 'offer') {
            this.$http.post(`${this.apiUrl}/update-offer-position`, data).then(
                (response) => {
                    const offerId = response.data.data['0'].order_id;
                    if (response.data.meta.success) {
                        this.$window.location.href = (response.data.data['0'].isCompany) ? `/shop/offers/summary/${offerId}` : `/shop/offers/employee-summary/${offerId}`;
                    }
                },
            );
        }
    }
}

ApiService.$inject = [
    'config',
    '$http',
    '$window',
    '$injector',
    '$rootScope',
    '$translate'
];

export default angular.module('apiService', [])
    .service('apiService', ApiService)
    .name;
